// @ts-nocheck
import {useState} from 'react'
import axios from 'axios'
import {useAuth} from '../modules/auth'

const API_URL = process.env.REACT_APP_API_URL || ''

// Blocking gate shown after login when the account is missing its name and/or phone
// (e.g. a fresh Google sign-up). The app can't be used until both are provided; once
// saved we arm the onboarding wizard and reload into it. Admin-switched sessions are
// never blocked (the backend sets profile_gate.blocking = false for them).
const overlay: React.CSSProperties = {position: 'fixed', inset: 0, zIndex: 1200, background: 'rgba(15,23,42,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16}
const sheet: React.CSSProperties = {direction: 'rtl', width: '100%', maxWidth: 440, background: '#fff', borderRadius: 16, boxShadow: '0 20px 60px rgba(0,0,0,0.3)', padding: 28}
const input: React.CSSProperties = {width: '100%', padding: '11px 14px', border: '1px solid #e5e7eb', borderRadius: 10, fontSize: 15}

export default function ProfileGate() {
  const {currentUser} = useAuth()
  const gate = currentUser?.profile_gate

  const [name, setName] = useState(
    currentUser?.first_name ? `${currentUser.first_name} ${currentUser.last_name || ''}`.trim() : ''
  )
  const [phone, setPhone] = useState(
    currentUser?.phone && !String(currentUser.phone).includes('.') ? String(currentUser.phone) : ''
  )
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')

  if (!gate?.blocking) return null

  const needsName = gate.needs_name
  const needsPhone = gate.needs_phone

  const submit = async () => {
    setErr('')
    if (needsName && !name.trim()) { setErr('נא להזין שם מלא'); return }
    if (needsPhone && String(phone).replace(/\D/g, '').length < 9) { setErr('נא להזין מספר טלפון תקין'); return }
    setBusy(true)
    try {
      const payload: any = {}
      if (needsName) {
        const parts = name.trim().split(/\s+/)
        payload.first_name = parts[0] || ''
        payload.last_name = parts.slice(1).join(' ')
      }
      if (needsPhone) payload.phone = phone.trim()
      await axios.post(`${API_URL}/api/update-profile`, payload)
      // Arm the onboarding wizard, then reload into it (a fresh verify_token clears the gate).
      try { localStorage.setItem('onboarding_pending', '1') } catch (_) {}
      window.location.href = '/campaigns?onboarding=1'
    } catch (e: any) {
      setErr(e?.response?.data?.error || 'שמירה נכשלה, נסו שוב')
      setBusy(false)
    }
  }

  return (
    <div style={overlay}>
      <div style={sheet}>
        <h3 style={{fontWeight: 800, marginBottom: 6}}>עוד רגע לפני שמתחילים 👋</h3>
        <p style={{color: '#6b7280', marginBottom: 20}}>נשלים כמה פרטים כדי שנוכל להתאים לכם את המערכת וליצור קשר בעת הצורך.</p>
        {needsName && (
          <div style={{marginBottom: 14}}>
            <label style={{display: 'block', fontWeight: 600, fontSize: 13, marginBottom: 6}}>שם מלא</label>
            <input autoFocus value={name} onChange={(e) => setName(e.target.value)} placeholder='שם פרטי ומשפחה' style={input} />
          </div>
        )}
        {needsPhone && (
          <div style={{marginBottom: 14}}>
            <label style={{display: 'block', fontWeight: 600, fontSize: 13, marginBottom: 6}}>טלפון נייד</label>
            <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder='05X-XXXXXXX' type='tel' inputMode='tel' style={input} />
          </div>
        )}
        {err && <div style={{color: '#dc2626', fontSize: 13, marginBottom: 10}}>{err}</div>}
        <button onClick={submit} disabled={busy}
          style={{width: '100%', padding: '12px 16px', borderRadius: 10, border: 'none', background: '#2b70fa', color: '#fff', fontWeight: 700, fontSize: 15, cursor: busy ? 'wait' : 'pointer', opacity: busy ? 0.6 : 1}}>
          {busy ? 'שומר…' : 'המשך'}
        </button>
      </div>
    </div>
  )
}
